import type { SVGProps } from 'react'
const IconPinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.25 21.75a.75.75 0 0 1-.75-.75v-3.925H8.26a2.686 2.686 0 0 1-2.1-4.365l.94-1.176c.324-.407.504-.911.509-1.432l.023-2.61a1.25 1.25 0 0 0-.455-.89 2.48 2.48 0 0 1-.8-2.083 2.59 2.59 0 0 1 2.6-2.269h6.545a2.59 2.59 0 0 1 2.6 2.27 2.48 2.48 0 0 1-.8 2.082 1.25 1.25 0 0 0-.452.891l.023 2.606c.005.522.184 1.027.509 1.436l.94 1.175a2.687 2.687 0 0 1-2.1 4.365H13V21a.75.75 0 0 1-.75.75m-3.27-18a1.09 1.09 0 0 0-1.108.91.99.99 0 0 0 .318.834 2.71 2.71 0 0 1 .942 2.011l-.023 2.61a3.84 3.84 0 0 1-.836 2.355l-.941 1.176a1.188 1.188 0 0 0 .928 1.93h7.98a1.187 1.187 0 0 0 .929-1.93l-.94-1.176a3.84 3.84 0 0 1-.837-2.359l-.023-2.6a2.7 2.7 0 0 1 .94-2.01 1 1 0 0 0 .32-.835 1.077 1.077 0 0 0-1.108-.91zm3.27 7.463a.75.75 0 0 1-.75-.75V7.92a.75.75 0 0 1 1.5 0v2.543a.75.75 0 0 1-.75.75"
    />
  </svg>
)
export default IconPinIcon
